<template>
  <div class="text-white flex items-center space-x-2 text-lg ml-3 mt-5">
    <AIHistoryIcon class="w-5 h-5" />
    <div>{{ $t("History") }}</div>
  </div>
  <div class="mt-4 text-white font-light">
    <div
      v-for="history_item in history_items"
      :key="history_item.id"
      class="flex items-center space-x-2 hover:bg-white transition-all ease-in-out hover:text-[#841FF4] py-2 cursor-pointer"
      @mouseleave="history_hovered = null"
      @mouseenter="history_hovered = history_item.id">
      <AIHistoryThumbIcon
        :color="history_hovered == history_item.id ? '#841FF4' : 'white'"
        :class="[{ 'rotate-180': history_item.sign == 'negative' }]"
        class="w-3 h-3 font-normal ml-4" />
      <div class="truncate w-5/6">
        {{ history_item.text }}
      </div>
    </div>
  </div>
</template>

<script>
import AIHistoryThumbIcon from "@/components/shared/icons/AIHistoryThumbIcon"
import AIHistoryIcon from "@/components/shared/icons/AIHistoryIcon"
export default {
  components: { AIHistoryThumbIcon, AIHistoryIcon },
  props: {},
  emits: [],
  data() {
    return {
      history_hovered: null,

      history_items: [
        { text: this.$t("Show me my top three churned goals and tasks"), sign: "positive", id: 1 },
        { text: this.$t("What should I do about my lowest goals"), sign: "negative", id: 2 },
        { text: this.$t("Do you recommend me to do this whatever"), sign: "negative", id: 3 },
        { text: this.$t("Show me top goals"), sign: "positive", id: 4 }
      ]
    }
  },
  watch: {},

  created() {},

  methods: {}
}
</script>
